import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useParams } from "react-router-dom";
import {
  //   DownloadPDFPalishReceiptDetails,
  getPalishReceiptById,
} from "./services/palishReceipt.services";
import { clearPalishReceiptDetail } from "./palishReceiptSlice";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { PRINT_ACCESS } from "../../_contstants/common";
import { IoMdPrint } from "react-icons/io";
import moment from "moment";
import { LoadingPanel } from "../../components/layout/Loading";
// import { MdOutlineFileDownload } from "react-icons/md";
// import { API_URL } from "../../app/config";
// import { ErrorToast } from "../../components/toast/Toasts";

const PalishReceiptVoucherPDF = () => {
  const dispatch = useAppDispatch();
  const param = useParams();
  const palish_receipt_guid = param?.palish_receipt_guid || "";
  const PalishReceiptDetail = useAppSelector(
    (state) => state.palishreceipt.PalishReceiptDetail,
  );
  const karigarIdWiseOutStandingAmount =
    PalishReceiptDetail?.karigarIdWiseOutStandingAmount &&
    PalishReceiptDetail?.karigarIdWiseOutStandingAmount?.length > 0
      ? PalishReceiptDetail?.karigarIdWiseOutStandingAmount[0]
      : {};
  const loading = useAppSelector((state) => state.palishreceipt.loading);
  const isPrintAccess = checkAcessRights("/palishreceipt", PRINT_ACCESS);
  const gridRef = useRef<any>(null);
  // const [withImage, setWithImage] = useState(false);

  // const handleWithImage = () => {
  //   setWithImage((pre) => !pre);
  // };

  useEffect(() => {
    return () => {
      dispatch(clearPalishReceiptDetail());
    };
  }, []);

  useEffect(() => {
    if (palish_receipt_guid) {
      dispatch(getPalishReceiptById(palish_receipt_guid));
    }
  }, [palish_receipt_guid]);

  useEffect(() => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .no-print {
          display: none !important;
        }
        .receipt-order-item-print-break {
          page-break-inside: avoid;
        }
        .container {
          width: 100% !important;
          max-width: 100% !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        body {
          zoom: 70% !important;
        }
        .table-bordered, .table-bordered td, .table-bordered th {
          border: 1px solid #c2c2c2ff !important;
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handlePrint = () => {
    window.print();
  };

/*
  const handleDownloadPdf = async (
    palish_receipt_guid: string,
    palish_receipt_no: any,
  ) => {
    try {
      const response = await fetch(
        `${API_URL}/Palish/FIndByIDPalishDownloadPDf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            palish_receipt_guid,
            // isimageview: withImage,
          }),
        },
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Palish-receipt-${
        palish_receipt_no || moment().date()
      }.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download PDF! - Please try again later");
    }
  };
*/

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}

      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <div
            className="printbuttons no-print"
            style={{
              textAlign: "center",
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {isPrintAccess && (
              <>
                {/* <div
                  style={{
                    marginRight: "10px",
                    padding: "3px 10px",
                    border: "none",
                  }}
                >
                  <Checkbox
                    label="With Image "
                    size="large"
                    labelPlacement="before"
                    onChange={handleWithImage}
                    checked={withImage}
                  />
                </div> */}
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handlePrint}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              </>
            )}
            {/* {isPrintAccess && (
              <Button
                type="button"
                style={{
                  marginRight: "10px",
                  padding: "5px 10px",
                  border: "none",
                }}
                fillMode={"solid"}
                themeColor={"tertiary"}
                onClick={() =>
                  handleDownloadPdf(
                    palish_receipt_guid,
                    PalishReceiptDetail.palish_receipt_no,
                  )
                }
              >
                <MdOutlineFileDownload style={{ fontSize: "20px" }} /> Download
              </Button>
            )} */}
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <Typography.h5
            style={{
              marginBottom: 0,
              textAlign: "center",
            }}
          >
            PALISH RECEIPT VOUCHER
          </Typography.h5>
          <Typography.h6
            style={{
              marginBottom: 15,
              textAlign: "center",
            }}
          >
            RECEIPT NO : {PalishReceiptDetail?.palish_receipt_no} | RECEIPT DATE
            : {moment(PalishReceiptDetail?.receipt_date).format("DD/MM/YYYY")}
          </Typography.h6>
        </GridLayoutItem>
      </GridLayout>

      <div className="container">
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            flexDirection: "column",
            marginBottom: 10,
          }}
        >
          <div className="card-header bg-light">
            <h5 className="mb-0 fw-bold">Karigar Stock</h5>
          </div>
          <div className="stock-container">
            <div className="stock-item w-100">
              <div className="stock-header">
                <div
                  className={`indicator-dot amount-dot-${karigarIdWiseOutStandingAmount.Amount_credit_debit}`}
                ></div>
                <Typography.h6 className="stock-label">
                  Amount Balance
                </Typography.h6>
              </div>
              <Typography.h6
                className={`stock-value text-nowrap amount-value-${karigarIdWiseOutStandingAmount.Amount_credit_debit}`}
              >
                ₹
                {formatToIndianCurrencyWithoutSymbol(
                  karigarIdWiseOutStandingAmount.amount || 0,
                )}{" "}
                <span
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    fontSize: 16,
                  }}
                >
                  {karigarIdWiseOutStandingAmount.Amount_credit_debit}
                </span>
              </Typography.h6>
            </div>

            <div className="stock-item  w-100">
              <div className="stock-header">
                <div
                  className={`indicator-dot phine-dot-${karigarIdWiseOutStandingAmount.phine_credit_debit}`}
                ></div>
                <Typography.h6 className="stock-label">
                  Phine (gm) Stock
                </Typography.h6>
              </div>
              <Typography.h6
                className={`stock-value phine-value-${karigarIdWiseOutStandingAmount.phine_credit_debit}`}
              >
                {formatWeight(karigarIdWiseOutStandingAmount.phine)}{" "}
                <span
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    fontSize: 16,
                  }}
                >
                  {karigarIdWiseOutStandingAmount.phine_credit_debit}
                </span>
              </Typography.h6>
            </div>
          </div>
        </div>
        {/* Summary Information */}
        <div className="card summary-card mb-3">
          <div className="card-header bg-light">
            <h5 className="mb-0 fw-bold">Order Summary</h5>
          </div>
          <div className=" p-0">
            <table className="table table-bordered mb-0">
              <tbody>
                <tr>
                  <td style={{ width: "20%" }}>
                    <strong>Karigar</strong>
                    <br />
                    <span>{PalishReceiptDetail?.karigar_name}</span>
                  </td>
                  <td style={{ width: "20%" }}>
                    <strong>Charges</strong>
                    <br />
                    <span>{PalishReceiptDetail?.charges}</span>
                  </td>
                  <td style={{ width: "20%" }}>
                    <strong>Gold Rate (GM)</strong>
                    <br />
                    <span>{PalishReceiptDetail?.gold_rate}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {PalishReceiptDetail?.palish_receipt_order?.length > 0 && (
            <div className="card items-card mt-1">
              <div className="card-header bg-light p-1">
                <h5 className="mb-0 fw-bold">Palish Receipt Orders</h5>
              </div>
              <div className="card-body p-0">
                <div className="approval-table">
                  <table className="table table-bordered mb-0 approval-items-table">
                    <thead>
                      <tr>
                        <th style={{ width: "5%" }}>Order No</th>
                        {/* <th
                          style={{ width: "10%" }}
                          className={`${!withImage && `no-print`}`}
                        >
                          Image
                        </th> */}
                        <th style={{ width: "20%" }}>Product Name</th>
                        <th style={{ width: "10%" }}>Issue Date</th>
                        <th style={{ width: "10%" }}>Issue Weight (gm)</th>
                        <th style={{ width: "13%" }}>Received Weight (gm)</th>
                        <th style={{ width: "10%" }}>Total Charge</th>
                        <th style={{ width: "10%" }}>Ghat Weight (gm)</th>
                        <th style={{ width: "10%" }}>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {PalishReceiptDetail?.palish_receipt_order?.map(
                        (receipt_order: any, idx: number) => {
                          return (
                            <tr key={receipt_order?.id || idx}>
                              <td>{receipt_order?.order_id}</td>
                              {/* <td className={`${!withImage && `no-print`}`}>
                                {receipt_order?.Image && (
                                  <img
                                    className="img-fluid object-fit-cover"
                                    src={receipt_order?.Image}
                                    alt="Process Image"
                                  />
                                )}
                              </td> */}
                              <td>{receipt_order?.item_name}</td>
                              <td>
                                {receipt_order?.issue_date &&
                                  moment(receipt_order?.issue_date).format(
                                    "DD/MM/YYYY",
                                  )}
                              </td>
                              <td>
                                {formatWeight(receipt_order?.issue_weight)}
                              </td>
                              <td>
                                {formatWeight(receipt_order?.received_weight)}
                              </td>
                              <td>{receipt_order?.total_charge}</td>
                              <td>
                                {formatWeight(receipt_order?.ghat_weight)}
                              </td>
                              <td>{receipt_order?.amount}</td>
                            </tr>
                          );
                        },
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PalishReceiptVoucherPDF;
